import { AxiosResponse } from "axios";
import qs from "qs";
import { AxiosInstance } from "./axiosInstance";
import {
  CreateAccountRequest,
  GetAccountListResponse,
  getAccoountNumberResponse,
  CUDAccountResponse,
  getAccoountNumberRequest,
  TransferResponse,
  TransferRequest,
  DecideRequest,
  DecideResponse,
  GetAdminUserResponse,
  SuspendedPayload,
  AccountAccessCheckRequest,
  AccountAccessCheckResponse,
} from "./interfaces/accountInterface.interface";
import {
  BasePagination,
  CustomError,
} from "./interfaces/commonInterface.interface";
import { setAxiosHeaders } from "utils/AuthUtil";

const API_PATH = "/account";

export const getAccountDetail = async (
  accountId: string
): Promise<CUDAccountResponse> => {
  try {
    const { data }: AxiosResponse<CUDAccountResponse> = await AxiosInstance.get(
      `${API_PATH}/${accountId}`
    );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const getAccoountList = async ({
  payload,
  accountId,
  isSelf,
}: {
  payload: BasePagination;
  accountId: string;
  isSelf: boolean;
}): Promise<GetAccountListResponse> => {
  try {
    const { data }: AxiosResponse<GetAccountListResponse> =
      await AxiosInstance.get(
        `${API_PATH}/list/${accountId}/${isSelf}?${qs.stringify(payload)}`
      );
    return data;
    //return getAccountListMappger(data.result);
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getAccountTreeList = async ({
  payload,
  accountId,
  isSelf,
}: {
  payload: BasePagination;
  accountId: string;
  isSelf: boolean;
}): Promise<GetAccountListResponse> => {
  try {
    const { data }: AxiosResponse<GetAccountListResponse> =
      await AxiosInstance.get(
        `${API_PATH}/treeList/${accountId}/${isSelf}?${qs.stringify(payload)}`
      );
    return data;
    //return getAccountListMappger(data.result);
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getSwitchAccountList = async ({
  payload,
}: {
  payload: BasePagination;
}): Promise<GetAccountListResponse> => {
  try {
    setAxiosHeaders({
      roleId: localStorage.getItem("r-mem") as string,
    });
    const res: AxiosResponse<GetAccountListResponse> =
      await AxiosInstance.get(
        `${API_PATH}/switch/list?${qs.stringify(payload)}`
      );
    return res?.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  } finally {
    setAxiosHeaders()
  }
};

export const getAccoountTotalList = async ({
  accountId,
  userId,
}: {
  accountId: string;
  userId: string | undefined;
}): Promise<GetAccountListResponse> => {
  try {
    /**
     * @todo API 정상동작 후 제거
     */
    // if (process.env.NODE_ENV === "development") {
    //   return getAccountListMappger(GET_ACCOUNT_LIST.data as any); // @todo delete
    // }
    // return getAccountListMappger(GET_ACCOUNT_LIST.data as any); // @todo delete
    const { data }: AxiosResponse<GetAccountListResponse> =
      userId !== undefined
        ? await AxiosInstance.get(
            `${API_PATH}/totalList/${accountId}/${userId}`
          )
        : await AxiosInstance.get(`${API_PATH}/totalList/${accountId}`);
    return data;
    //return getAccountListMappger(data.result);
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getAccountAdminUsers = async ({
  accountId,
}: {
  accountId: string;
}): Promise<GetAdminUserResponse> => {
  try {
    const { data }: AxiosResponse<GetAdminUserResponse> =
      await AxiosInstance.get(`${API_PATH}/adminUsers/${accountId}`);
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const getAccoountNumber = async ({
  payload,
  accountId,
}: {
  payload: getAccoountNumberRequest;
  accountId: string;
}): Promise<getAccoountNumberResponse> => {
  try {
    const { data }: AxiosResponse<getAccoountNumberResponse> =
      await AxiosInstance.post(
        `${API_PATH}/accountNumber/${accountId}`,
        payload
      );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postUpdateSuspension = async ({
  suspensionStatus,
  accountId,
  targetAccountId,
}: SuspendedPayload): Promise<CUDAccountResponse> => {
  try {
    const { data }: AxiosResponse<CUDAccountResponse> =
      await AxiosInstance.post(`${API_PATH}/update/suspension/${accountId}`, {
        targetAccountId,
        suspensionStatus,
      });
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postAccountCreate = async ({
  payload,
  accountId,
}: {
  payload: CreateAccountRequest;
  accountId: string;
}): Promise<CUDAccountResponse> => {
  try {
    const { data }: AxiosResponse<CUDAccountResponse> =
      await AxiosInstance.post(`${API_PATH}/create/${accountId}`, payload);
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postAccountAccessCheck = async (
  payload: AccountAccessCheckRequest
): Promise<AccountAccessCheckResponse> => {
  try {
    const res: AxiosResponse<AccountAccessCheckResponse> =
      await AxiosInstance.post(`${API_PATH}/access-check`, payload);
    return res?.data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postAccountFavorite = async ({
  isFavorite,
  accountId,
}: {
  isFavorite: boolean;
  accountId: string;
}): Promise<CUDAccountResponse> => {
  try {
    const { data }: AxiosResponse<CUDAccountResponse> =
      await AxiosInstance.post(
        `${API_PATH}/update/isFavorite/${accountId}/${isFavorite}`
      );
    return data;
  } catch (e) {
    console.error(e);
    throw new Error();
  }
};

export const postAccountTransfer = async ({
  payload,
}: {
  payload: TransferRequest;
}): Promise<TransferResponse> => {
  try {
    const { data }: AxiosResponse<TransferResponse> = await AxiosInstance.post(
      `${API_PATH}/transfer/${payload.originalAccountId}`,
      {
        targetAccountId: payload.targetAccountId,
        dstAccountNumber: payload.dstAccountNumber,
      }
    );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const postAccountDecide = async ({
  accountId,
  isDecide,
}: DecideRequest): Promise<DecideResponse> => {
  try {
    const { data }: AxiosResponse<DecideResponse> = await AxiosInstance.post(
      `${API_PATH}/update/isDecide/${accountId}`,
      {
        isDecide: isDecide,
      }
    );
    return {
      ...data,
      result: {
        isDecide: isDecide,
      },
    };
  } catch (e) {
    const customErr = e as CustomError;
    throw Promise.reject({
      ...customErr,
      response: {
        ...(customErr.response || {}),
        data: {
          ...(customErr.response?.data || {}),
          result: {
            isDecide: isDecide,
          },
        },
      },
    });
  }
};

export const putAccountUpdate = async ({
  form,
  accountId,
}: {
  form: FormData;
  accountId: string;
}): Promise<CUDAccountResponse> => {
  try {
    const { data }: AxiosResponse<CUDAccountResponse> = await AxiosInstance.put(
      `${API_PATH}/update/${accountId}`,
      form
    );
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};

export const deleteAccount = async (
  accountId: string
): Promise<CUDAccountResponse> => {
  try {
    const { data }: AxiosResponse<CUDAccountResponse> =
      await AxiosInstance.delete(`${API_PATH}/delete/${accountId}`);
    return data;
  } catch (e) {
    const customErr = e as CustomError;
    throw customErr;
  }
};
